import React, { useMemo } from 'react';
import { useCurrentUser, VISITOR } from '@applyboard/ab-common';
import AppContext from "./AppContext";
import { BUTTON } from "../../Common/Constants";
export var getLastButtonText = function getLastButtonText(programId, showSaveAndExitModal) {
  return programId === null ? showSaveAndExitModal ? BUTTON.SHOW_RESULTS : BUTTON.EXPLORE_PROGRAMS : BUTTON.SHOW_RESULT;
};
var AppProvider = function AppProvider(_ref) {
  var _user$0$role, _user$, _user$2, _user$2$relationships, _user$2$relationships2, _user$2$relationships3;
  var userId = _ref.userId,
    studentId = _ref.studentId,
    userRole = _ref.userRole,
    programId = _ref.programId,
    children = _ref.children,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? null : _ref$onSubmit,
    showSaveAndExitModal = _ref.showSaveAndExitModal,
    _ref$onboardingMode = _ref.onboardingMode,
    onboardingMode = _ref$onboardingMode === void 0 ? false : _ref$onboardingMode,
    exploreAction = _ref.exploreAction,
    ineligibleRegisterRedirect = _ref.ineligibleRegisterRedirect;
  var user = useCurrentUser();
  var fallbackUserRole = (_user$0$role = (_user$ = user[0]) === null || _user$ === void 0 ? void 0 : _user$.role) !== null && _user$0$role !== void 0 ? _user$0$role : VISITOR;
  // use passed in userRole if it exists; otherwise fall back to role from useCurrentUser (which might not be loaded yet)
  var currentUserRole = userRole !== null && userRole !== void 0 ? userRole : fallbackUserRole;
  var fallbackStudentId = studentId !== null && studentId !== void 0 ? studentId : (_user$2 = user[0]) === null || _user$2 === void 0 ? void 0 : (_user$2$relationships = _user$2.relationships) === null || _user$2$relationships === void 0 ? void 0 : (_user$2$relationships2 = _user$2$relationships.student_information) === null || _user$2$relationships2 === void 0 ? void 0 : (_user$2$relationships3 = _user$2$relationships2.data) === null || _user$2$relationships3 === void 0 ? void 0 : _user$2$relationships3.id;
  var lastButtonText = getLastButtonText(programId, showSaveAndExitModal);
  var appContext = useMemo(function () {
    return {
      programId: programId,
      userId: userId,
      studentId: fallbackStudentId,
      userRole: currentUserRole,
      onSubmit: onSubmit,
      showSaveAndExitModal: showSaveAndExitModal,
      lastButtonText: lastButtonText,
      onboardingMode: onboardingMode,
      exploreAction: exploreAction,
      ineligibleRegisterRedirect: ineligibleRegisterRedirect
    };
  }, [programId, userId, fallbackStudentId, currentUserRole, onSubmit, showSaveAndExitModal, lastButtonText, onboardingMode, exploreAction, ineligibleRegisterRedirect]);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: appContext
  }, children);
};
var useAppContext = function useAppContext() {
  var context = React.useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within a AppProvider');
  }
  return context;
};
export { AppProvider, useAppContext };